import React from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbDivider,
  BreadcrumbButton,
  makeStyles,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    "& a, button": {
      fontSize: "1.125rem",
    },
    "& a:hover": {
      backgroundColor: "transparent",
    },
    "& button:hover": {
      backgroundColor: "transparent",
    },
    "& .hasHref:hover": {
      textDecoration: "underline",
    },
    "& button:focus": {
      outline: "none",
    },
  },
});

export default function FluentBreadcrumb({ breadcrumbs }) {
  const styles = useStyles();
  const history = useHistory();

  return (
    <Breadcrumb className={styles.root}>
      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbItem key={breadcrumb.Text}>
          <BreadcrumbButton
           className={breadcrumb.Href ? "hasHref" : ""}
            current={index === breadcrumbs.length - 1}
            onClick={() => {
              if (breadcrumb.Href) history.push(breadcrumb.Href);
              else if (breadcrumb.clickevent !== undefined)
                breadcrumb?.clickevent();
            }}
          >
            {breadcrumb.Text}
          </BreadcrumbButton>
          {index < breadcrumbs.length - 1 && <BreadcrumbDivider />}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}

FluentBreadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      Href: PropTypes.string,
      Text: PropTypes.string.isRequired,
    })
  ).isRequired,
};
